const DEFAULT_SITE_PLACEHOLDER = 'First floor';

/** Substitute the catalog site placeholder with the active workspace site. */
export function siteScopedAssistantHint(hint: string, site: string): string {
  return hint.replace(DEFAULT_SITE_PLACEHOLDER, site);
}
